export const formatTagName = (name: string) => name.replace(/_/g, ' ')
